// Fix jQuery passive listener
jQuery.event.special.touchstart = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.touchmove = {
    setup: function( _, ns, handle ) {
        this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
    }
};
jQuery.event.special.wheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("wheel", handle, { passive: true });
    }
};
jQuery.event.special.mousewheel = {
    setup: function( _, ns, handle ){
        this.addEventListener("mousewheel", handle, { passive: true });
    }
};

jQuery(document).ready(function ($) {
    function debounce(func, wait) {
        var timer = null;
        return function() {
            clearTimeout(timer);
            timer = setTimeout(func, wait);
        }
    }

    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    var vh = window.innerHeight * 0.01; // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', "".concat(vh, "px")); // We listen to the resize event

    window.addEventListener('resize', debounce(function(){
        // We execute the same script as before
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
    }, 100));

    // Verificar qual tamanho da barra de rolagem
    function getScrollbarWidth() {
        // Creating invisible container
        var outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll'; // forcing scrollbar to appear
        outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
        document.body.appendChild(outer);

        // Creating inner element and placing it in the container
        var inner = document.createElement('div');
        outer.appendChild(inner);

        // Calculating difference between container's full width and the child width
        var scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

        // Removing temporary elements from the DOM
        outer.parentNode.removeChild(outer);

        return scrollbarWidth;
    }

    // Stick header
    var header = $('#header');
    var headerTopDistance = $(window).scrollTop();
    var headerHeight = header.outerHeight();
    var headerInnerHeight = header.height();

    if (headerTopDistance > 100) {
        header.addClass("header-stick");
    }

    // Scroll listener
    window.addEventListener('scroll', debounce(function(){
        headerTopDistance = $(window).scrollTop();

        if (headerTopDistance > 100) {
            header.addClass("header-stick");
        } else {
            header.removeClass("header-stick");
        }
    }, 10));

    // Other vars
    var scrollbar = getScrollbarWidth();

    // Menu mobile vars
    var btnMenuMobile = $('.btn-menu-mobile');
    var menuMobile = $('.menu-mobile');
    var menuOverlay = $('.menu-mobile-overlay');

    // Open menu mobile
    function openMenuMobile() {
        var headerMobileHeight = header.outerHeight();

        btnMenuMobile.addClass('is-active');
        menuMobile.addClass('is-active');
        header.addClass('menu-mobile-active');
        menuOverlay.fadeIn();
        menuMobile.css({'padding-top': headerMobileHeight - 1 + 'px'});
        $('html').css({'margin-right': scrollbar+'px', 'overflow': 'hidden'});
    }

    // Close menu mobile
    function closeMenuMobile() {
        btnMenuMobile.removeClass('is-active');
        menuMobile.removeClass('is-active');
        header.removeClass('menu-mobile-active');
        menuOverlay.fadeOut();
        setTimeout(function(){
            $('html').css({'margin-right': '', 'overflow': ''});
        }, 300);
    }

    // Trigger menu mobile
    $('[data-menu-mobile="toggle"]').click(function(event) {
        if (menuMobile.hasClass('is-active')) {
            closeMenuMobile();
        } else {
            openMenuMobile();
        }
    });

    // Open submenu mobile
    $('.mobile-nav .menu-item-has-children').click(function(event) {
        $('.mobile-nav .sub-menu .menu-item').click(function(event) {
            event.stopPropagation();
        });
        if ($(this).children('.sub-menu').is(':visible')) {
            $(this).removeClass('is-active');
            $(this).children('.sub-menu').slideUp();
        } else {
            $(this).addClass('is-active');
            $(this).children('.sub-menu').slideDown();
        }
    });

    // Trigger faq (open/close)
    $('[data-faq="toggle"]').click(function(event) {
        if ($(this).siblings('.item-text').is(':hidden')) {
            $('.faq-item .item-header').removeClass('is-active');
            $('.faq-item .item-text').slideUp();
            $(this).addClass('is-active');
            $(this).siblings('.item-text').slideDown();
        } else {
            $(this).removeClass('is-active');
            $(this).siblings('.item-text').slideUp();
        }
    });

    // Load video on click
    /*
    var videoList = document.querySelectorAll(".video-load");

    videoList.forEach(function (videoItem) {
        videoItem.addEventListener("click", function (event) {

            var iframe = videoItem.querySelector("iframe");
            if (iframe) {
                var dataSrc = iframe.getAttribute("data-src");
                if (dataSrc) {
                    iframe.src = dataSrc;
                    setTimeout(function () {
                        videoItem.classList.add("video-loaded");
                    }, 1000);
                }
            }
        });
    });
    */

    // Anchor scroll
    $('a[href*="#"]:not([href="#"])').click(function (event) {
        event.preventDefault();
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var el = this;
            var hash = $($(this).attr('href'));
            var target = hash.length ? hash : $('[name=' + this.hash.slice(1) + ']');
            headerHeight = header.outerHeight();
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top-headerHeight
                }, 1000);
                
                // Mudar hash na URL
                history.pushState({}, '', el.href);
            }
        }
    });

    $('a[href="#"]').click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 1000);
    });

    var getLocation = function(href) {
        var l = document.createElement("a");
        l.href = href;
        return l;
    };

    $('.video-popup').magnificPopup({
        // disableOn: 700,
        delegate: 'a',
        type: 'iframe',
        mainClass: 'mfp-fade',
        removalDelay: 300,
        preloader: false,
        fixedContentPos: true,
        iframe: {
            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                },
                vimeo: {
                    index: 'vimeo.com/',
                    id: function getVimeoVideoId(url) {
                        var urlPath = getLocation(url);
                        urlPath = urlPath.pathname.split('/');
                        var urlFinal = urlPath[1] + '?autoplay=1';

                        if (urlPath.length > 2) {
                            urlFinal = urlPath[1] + '?h=' + urlPath[2] + '&autoplay=1';
                        }

                        return urlFinal;
                    },
                    src: '//player.vimeo.com/video/%id%'
                },
            },
        }
    });

    // -------------------------------------
    // #SLICK
    // -------------------------------------

    var prevArrow = '<button class="slick-prev slick-arrow" type="button" aria-label="Anterior"><svg viewBox="0 0 24 24"><use href="#icon-arrow-circle"></use></svg></button>';
    var nextArrow = '<button class="slick-next slick-arrow" type="button" aria-label="Próximo"><svg viewBox="0 0 24 24"><use href="#icon-arrow-circle"></use></svg></button>';

    $('#slick-depoimento').slick({
        infinite: true,
        centerMode: true,
        centerPadding: '27%',
        focusOnSelect: true,
        speed: 500,
        dots: true,
        appendDots: $('#depoimento-slider-dots'),
        arrows: true,
        prevArrow: prevArrow,
        nextArrow: nextArrow,   
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: false,
        swipeToSlide: true,
        lazyLoad: 'progressive',
        responsive: [
            {
                breakpoint: 1280,
                settings: {
                    centerPadding: '20%',
                }
            },
            {
                breakpoint: 840,
                settings: {
                    centerPadding: '10%',
                }
            }
        ]
    });
});

document.addEventListener("DOMContentLoaded", function() {
    var videoList = document.querySelectorAll(".video-load");

    videoList.forEach(function (videoItem) {
        var iframe = videoItem.querySelector("iframe");
        if (iframe) {
            var dataSrc = iframe.getAttribute("data-src");
            if (dataSrc) {       
                iframe.src = dataSrc;         
                setTimeout(function () {                    
                    videoItem.classList.add("video-loaded");
                }, 1000);
            }
        }
    });
});